module.exports = __webpack_public_path__ + "assets/img/yukon-sport.52017356.png";